import type { BookingflowStateMachine } from '../../bookingflowstatemachine'
import { State } from '../../states/state'
import type {
    FeeSize,
    OnBehalfOf,
} from '../cancelbookingAdminState/cancelBookingAdminState.types'
import {
    ConfirmCancellationAdminActions,
    ConfirmCancellationAdminStateDependencies,
    IGetData,
    confimCancellationAdminStateActions,
    confirmCancellationAdminActions,
} from './confirmCancellationAdminState.types'

const CONFIRM_CANCELLATION_ADMIN_STATE = 'CONFIRM_CANCELLATION_ADMIN_STATE'

export class ConfirmCancellationAdminState extends State<
    ConfirmCancellationAdminActions,
    typeof CONFIRM_CANCELLATION_ADMIN_STATE
> {
    public readonly type = CONFIRM_CANCELLATION_ADMIN_STATE

    private _cancellationFeeSize: FeeSize
    private _shouldCloseTime: boolean
    private _cancelOnBehalfOf: OnBehalfOf
    private _shouldSendCustomerMessages: boolean
    private _shouldSendPartnerMessages: boolean
    private _cancelReason: string

    private _isConfirmed = false // Not sure yet if we gonna use this. Doing Next action is the same as confirmation. (Business Rule)

    constructor(
        bookingflowStateMachine: BookingflowStateMachine,
        dependencies: ConfirmCancellationAdminStateDependencies
    ) {
        super(bookingflowStateMachine)
        const {
            cancelOnBehalfOf,
            cancellationFeeSize,
            shouldCloseTime,
            shouldSendCustomerMessages,
            shouldSendPartnerMessages,
            cancelReason,
        } = dependencies
        this._cancelOnBehalfOf = cancelOnBehalfOf
        this._cancellationFeeSize = cancellationFeeSize
        this._shouldCloseTime = shouldCloseTime
        this._shouldSendCustomerMessages = shouldSendCustomerMessages
        this._shouldSendPartnerMessages = shouldSendPartnerMessages
        this._cancelReason = cancelReason
    }

    public doAction(
        action: ConfirmCancellationAdminActions
    ): ConfirmCancellationAdminState {
        switch (action.type) {
            case 'SET_IS_CONFIRMED':
                this._isConfirmed = action.data
                return this
            default:
                throw new Error('These are not the droids you are looking for')
        }
    }

    public getActions = (): confimCancellationAdminStateActions[] =>
        confirmCancellationAdminActions.filter((action) =>
            new action(this).isDoable()
        )

    public get isConfirmed(): boolean {
        return this._isConfirmed
    }

    public getData(): IGetData {
        return {
            isConfirmed: this._isConfirmed,
            cancellationFeeSize: this._cancellationFeeSize,
            shouldCloseTime: this._shouldCloseTime,
            cancelOnBehalfOf: this._cancelOnBehalfOf,
            shouldSendCustomerMessages: this._shouldSendCustomerMessages,
            shouldSendPartnerMessages: this._shouldSendPartnerMessages,
            cancelReason: this._cancelReason,
        }
    }

    public unset = (): void => {
        return
    }
}
